import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './CardChangeButton.module.scss';

const CardChangeButton = ({ text = 'Изменить', className, ...props }) => {
  return (
    <Button {...props} className={cn(styles.root, className)} type="link">
      {text}
    </Button>
  );
};

export default CardChangeButton;
